import {Button, Col, Form, InputGroup, Nav, Row} from "react-bootstrap";
import {GrClearOption} from "react-icons/gr";

const MembersSearch = (props) => {
    const handleSearch = (e) => {
        e.preventDefault()
        props.setSearch({})
        // props.setPageUrl('/api/payers/v1?page=1')

        for (let i of document.querySelectorAll('form input')) {
            if (i.value != '') {
                const name = i.getAttribute('name');
                const value = i.value;
                props.setSearch(search => ({
                        ...search, [name]: value
                    })
                )
            }
        }
    }
    const handleClear = (e) => {
        e.preventDefault();
        props.setSearch({})
        for (let i of document.querySelectorAll('form input, form select')) {
            i.value = ''
        }
    }
    return (
        <>
            <div className={'mb-3'}>
                <div className={'border-1 border-solid border-light'}>
                    <Row className={'align-content-center'}>
                        <Col md={8}><h5 className={'text-start fw-bold'}>Ricerca anagrafica</h5></Col>
                        <Col md={4} className={'text-end'}>
                            <GrClearOption className={'me-2 fs-4'} title={'Pulisci Filtri'} onClick={handleClear}/>
                        </Col>
                    </Row>
                    <Form className={'row  align-items-end'}>

                        <Form.Group className={'col-md-4 d-inline-block text-start  '}>
                            <Form.Label className={'small mb-0'}>Nome</Form.Label>
                            <Form.Control className={'form-control-sm mb-1'} name="name"
                                          placeholder={'Nome'}></Form.Control>
                        </Form.Group>
                        <Form.Group className={'col-md-2 d-inline-block text-start'}>
                            <Form.Label className={' small mb-0'}>Data di nascita</Form.Label>
                            <Form.Control className={'form-control-sm mb-1'} type={'date'} name="birth_date"
                                          placeholder={'Data di nascita'}></Form.Control>
                        </Form.Group>
                        <Col md={2}>
                            <Button type={"submit"} onClick={handleSearch}
                                    className={'w-100 btn btn-sm bkg-second no-border border-0 mb-1'}>Cerca</Button>
                        </Col>


                    </Form>
                </div>

            </div>
        </>
    )
}

export default MembersSearch